const focusAreas = [
  {
    title: 'Clean Architecture',
    description: 'Separation of concerns, modular design, and well-defined boundaries ensure systems that are easy to understand, test, and evolve over time.',
  },
  {
    title: 'Performance Optimization',
    description: 'Deep profiling, efficient resource management, and targeted optimizations deliver responsive and fluid experiences on every device.',
  },
  {
    title: 'User-Centered Design',
    description: 'Every interface decision starts with the people who will use it, resulting in intuitive, accessible, and polished interactions.',
  },
  {
    title: 'Long-Term Maintainability',
    description: 'Codebases structured for clarity and consistency, enabling teams to onboard quickly and iterate confidently without accumulating technical debt.',
  },
];

export default function FocusSection() {
  return (
    <section className="relative w-full bg-background-50 py-24 md:py-32 lg:py-40 px-8 md:px-16 lg:px-24 xl:px-32">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block px-3 py-1 border border-foreground-300/30 rounded-full text-xs tracking-[0.15em] uppercase text-foreground-400 font-medium mb-6">
            Core Focus
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-medium text-foreground-950 leading-[1.15] max-w-2xl mx-auto">
            What defines our engineering approach
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-500 max-w-xl mx-auto">
            Four pillars that guide every technical decision and shape the quality of every system we deliver.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {focusAreas.map((area) => (
            <div
              key={area.title}
              className="group bg-background-100 rounded-lg p-8 transition-colors duration-500"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-6">
                <div className="w-1.5 h-1.5 rounded-full bg-accent-500"></div>
              </div>
              <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-3 leading-tight">
                {area.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}